import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import "./Edit_MRM.css";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
import {
  Update,
  GetAll,
  GetSingle,
} from "../../../../../../../../src/features/admin/quality_management/management_system/Slice";

import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import { allManagement_System_Requirement_Status } from "../../../../../../../features/admin/common/Slice";

function Edit_MRM({ id, onCancel, managementsystemTypeId }) {
  const {
    handleSubmit,
    register,
    formState: { errors },
    setValue,
    reset,
    watch,
    getValues,
  } = useForm();
  const [success, setSuccess] = useState(false);
  const [filePreview, setFilePreview] = useState(null);
  const [existingFile, setExistingFile] = useState(null);
  const fileInputRef = React.useRef(null);
  const dispatch = useDispatch();
  const all_management_system_required_status = useSelector(
    (state) => state.common.all_management_system_required_status,
  );

  const singleData = useSelector((state) => state.management_system.single);

  useEffect(() => {
    if (id) {
      dispatch(GetSingle(id));
    }
    dispatch(allManagement_System_Requirement_Status());
  }, [id, dispatch]);

  useEffect(() => {
    if (!singleData) return;

    reset({
      attach_file: singleData.attach_file,
      name: singleData.name,
      start_date: singleData.start_date?.split("T")[0],
      end_date: singleData.end_date?.split("T")[0],
      remark: singleData.remark,
      management_system_requirement_status_id: String(
        singleData.management_system_requirement_status_id,
      ),
    });
  }, [singleData, reset]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setValue("attach_file", file, { shouldValidate: true });
      setFilePreview(URL.createObjectURL(file));
      setExistingFile(null); // user replaced old file
    }
  };

  //  auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);

  const onSubmit = async (data) => {
    const formData = new FormData();

    formData.append("name", data.name);
    formData.append("start_date", data.start_date);
    formData.append("end_date", data.end_date);
    formData.append("remark", data.remark);
    formData.append(
      "management_system_requirement_status_id",
      data.management_system_requirement_status_id,
    );

    formData.append("attach_file", data.attach_file[0]);

    const res = await dispatch(
      Update({
        id,
        sendData: formData,
      }),
    );

    if (res.meta.requestStatus === "fulfilled") {
      setSuccess(true);
      await dispatch(
        GetAll({
          page: 1,
          per_page: 10,
          management_system_type_id: managementsystemTypeId,
        }),
      );
      onCancel();
    }
  };

  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">
        {/* <h5 className="form_title mb-4">Edit MRM</h5> */}
        <div className="row">
          {/* Document Name */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Document Name</Form.Label>
              <Form.Control
                {...register("name", {
                  required: "Document Name is required",
                })}
                placeholder="Document Name"
              />
              {errors.name && (
                <Form.Text className="text-danger">
                  {errors.name.message}
                </Form.Text>
              )}{" "}
            </Form.Group>
          </div>

          {/* Start Date */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Start Date Of Last Internal Audit</Form.Label>
              <Form.Control
                type="date"
                {...register("start_date", {
                  required: "Start Date is required",
                  // validate: (value) => {
                  //   const year = value.split("-")[0];

                  //   if (year.length !== 4) {
                  //     return "Year must be exactly 4 digits";
                  //   }

                  //   const selectedDate = new Date(value);
                  //   const today = new Date();
                  //   today.setHours(0, 0, 0, 0);

                  //   if (selectedDate < today) {
                  //     return "Past dates are not allowed";
                  //   }

                  //   return true;
                  // },
                })}
                onChange={(e) => {
                  let value = e.target.value;
                  const parts = value.split("-");

                  if (parts[0] && parts[0].length > 4) {
                    parts[0] = parts[0].slice(0, 4);
                    e.target.value = parts.join("-");
                  }
                }}
              />
              {errors.start_date && (
                <Form.Text className="text-danger">
                  {errors.start_date.message}
                </Form.Text>
              )}{" "}
            </Form.Group>
          </div>

          {/* End Date */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>End Date Of Last Internal Audit</Form.Label>
              <Form.Control
                type="date"
                {...register("end_date", {
                  required: "End Date is required",
                  // validate: (value) => {
                  //   const year = value.split("-")[0];

                  //   if (year.length !== 4) {
                  //     return "Year must be exactly 4 digits";
                  //   }

                  //   const selectedDate = new Date(value);
                  //   const today = new Date();
                  //   today.setHours(0, 0, 0, 0);

                  //   if (selectedDate < today) {
                  //     return "Past dates are not allowed";
                  //   }

                  //   return true;
                  // },
                })}
                onChange={(e) => {
                  let value = e.target.value;
                  const parts = value.split("-");

                  if (parts[0] && parts[0].length > 4) {
                    parts[0] = parts[0].slice(0, 4);
                    e.target.value = parts.join("-");
                  }
                }}
              />
              {errors.end_date && (
                <Form.Text className="text-danger">
                  {errors.end_date.message}
                </Form.Text>
              )}{" "}
            </Form.Group>
          </div>

          {/* Action Taken */}
          <div className="col-md-12">
            <Form.Group className="form_group">
              <Form.Label>Action Taken:</Form.Label>

              <div className="row action_taken_group">
                {all_management_system_required_status?.map((status) => (
                  <div className="col-md-4 mt-2" key={status.value}>
                    <Form.Check
                      type="radio"
                      label={status.label}
                      value={String(status.value)}
                      {...register("management_system_requirement_status_id", {
                        required: "Action Taken is required",
                      })}
                    />
                  </div>
                ))}
              </div>

              {errors.management_system_requirement_status_id && (
                <Form.Text className="text-danger">
                  {errors.management_system_requirement_status_id.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          {/* Remark */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Remark</Form.Label>
              <Form.Control
                placeholder="Remark"
                {...register("remark", {
                  required: "Remark is required",
                })}
              />
              {errors.remark && (
                <Form.Text className="text-danger">
                  {errors.remark.message}
                </Form.Text>
              )}{" "}
            </Form.Group>
          </div>
        </div>
        <div className="dashed_border_holder"></div>
        <div className="row">
          <div className="note_text_hodler">
            <p className="red_text">
              To continue the process, please upload your evidence at your
              earliest convenience.
            </p>
          </div>
          {/* Attach File */}
          <div className="col-md-4">
            <Form.Group className="form_group file_field">
              <Form.Label>Attach File</Form.Label>

              <div className="absolute_fields">
                <Form.Control
                  type="file"
                  {...register("attach_file", {
                    required:
                      typeof getValues("attach_file") === "string"
                        ? false
                        : "File is required",
                  })}
                  accept="*"
                />

                <div className="upload_icon_holder">
                  <FontAwesomeIcon icon={faUpload} className="upload_icon" />
                </div>
              </div>

              {errors.attach_file && (
                <small className="text-danger">
                  {errors.attach_file.message}
                </small>
              )}

              {(() => {
                const fileValue = watch("attach_file");

                // URL for preview
                const fileUrl =
                  typeof fileValue === "string"
                    ? process.env.REACT_APP_IMG_URL + fileValue
                    : fileValue?.length > 0
                    ? URL.createObjectURL(fileValue[0])
                    : null;

                // Type detection
                const fileType =
                  typeof fileValue === "string"
                    ? fileValue.toLowerCase()
                    : fileValue?.[0]?.type;

                if (!fileUrl) return null;

                return (
                  <div className="preview-container">
                    {/* IMAGE */}
                    {(fileType?.includes("image") ||
                      fileType?.endsWith(".jpg") ||
                      fileType?.endsWith(".jpeg") ||
                      fileType?.endsWith(".png")) && (
                      <img
                        src={fileUrl}
                        alt="Preview"
                        className="image-preview"
                        style={{ maxWidth: "100px" }}
                      />
                    )}

                    {/* PDF */}
                    {(fileType === "application/pdf" ||
                      fileType?.endsWith(".pdf")) && (
                      <iframe
                        src={fileUrl}
                        style={{ maxWidth: "100px" }}
                        title="PDF"
                      />
                    )}

                    {/* WORD */}
                    {(fileType?.includes("word") ||
                      fileType?.endsWith(".doc") ||
                      fileType?.endsWith(".docx")) && (
                      <div>
                        <p>Word preview not supported</p>
                        <a
                          href={fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Open / Download Word File
                        </a>

                        <iframe
                          src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                          style={{ maxWidth: "100px" }}
                          title="Word Preview"
                        />
                      </div>
                    )}

                    {/* EXCEL */}
                    {(fileType?.includes("spreadsheet") ||
                      fileType?.endsWith(".xlsx") ||
                      fileType?.endsWith(".xls")) && (
                      <div>
                        <p>Excel preview not supported</p>
                        <a
                          href={fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Open / Download Excel File
                        </a>
                      </div>
                    )}
                  </div>
                );
              })()}
            </Form.Group>
          </div>
        </div>

        <div className="row">
          {singleData?.Management_System_Record_Files?.length > 0 &&
            singleData.Management_System_Record_Files.map((file, i) => {
              const fileUrl = process.env.REACT_APP_IMG_URL + file?.file;
              const fileType = (file?.file || "").toLowerCase();

              return (
                <div className="col-md-3 mb-3" key={i}>
                  <div className="image_holder">
                    <div>
                      {file?.Management_System_Requirement_Status?.name}
                    </div>

                    {/* IMAGE */}
                    {(fileType.includes("image") ||
                      fileType.endsWith(".jpg") ||
                      fileType.endsWith(".jpeg") ||
                      fileType.endsWith(".png")) && (
                      <img
                        src={fileUrl}
                        alt="Preview"
                        className="image-preview img-fluid"
                        style={{ maxWidth: "100px" }}
                      />
                    )}

                    {/* PDF */}
                    {fileType.endsWith(".pdf") && (
                      <iframe
                        src={fileUrl}
                        title="PDF Preview"
                        style={{ maxWidth: "100px" }}
                      />
                    )}

                    {/* WORD */}
                    {(fileType.endsWith(".doc") ||
                      fileType.endsWith(".docx")) && (
                      <div>
                        <a
                          href={fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          📄 Open Word File
                        </a>

                        <iframe
                          src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                          style={{ maxWidth: "100px" }}
                          title="Word Preview"
                        />
                      </div>
                    )}

                    {/* EXCEL */}
                    {(fileType.endsWith(".xls") ||
                      fileType.endsWith(".xlsx")) && (
                      <div>
                        <a
                          href={fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          📊 Open Excel File
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
        </div>

        {/* Action Buttons */}
        <div className="permission_btn_holder">
          {success ? (
            <Success_Toster successText="Save Audit Successfully!" />
          ) : (
            <>
              <Button
                type="button"
                className="permission_btn No_btn"
                onClick={onCancel}
              >
                Reset
              </Button>

              <Button
                type="button"
                className="permission_btn Yes_btn"
                onClick={handleSubmit(onSubmit)}
              >
                Save
              </Button>
            </>
          )}
        </div>
      </div>
    </section>
  );
}

export default Edit_MRM;
